export default {
    noPermissionToAccessApp: 'Sie haben keine Berechtigung, auf diese App zuzugreifen.',
    App: 'App',
}